<template>
    <div>
        <h1>{{ $t('tilkoebopsummering') }}</h1>
        <!-- <p>afterAddonData: {{ this.$store.getters.afterAddonData.booking.header.customer }}</p> -->
        <!-- <p>detailedEkstras: {{ this.$store.getters.afterAddonData.detailedEkstras }}</p> -->
        <!-- <p>ekstrasSummery: {{ this.ekstrasSummary }}</p> -->
        <!-- <p>Momssats: {{ this.momssats }}</p> -->
        <!-- <p>Fakturanr: {{ this.$store.getters.afterAddonData.booking.header.hotel.fakturanr }}</p> -->
        <!-- <p>Referencenummer: {{ this.$store.getters.afterAddonData.booking.header.hotel.refno }}</p> -->
        <!-- <p>postnr: {{ this.$store.getters.afterAddonData.hotel }}</p> -->
        <!-- <p>bookingInfo: {{ this.$store.getters.afterAddonData }}</p> -->
        <!-- <p>rabatinfo: {{ this.$store.getters.rabat }}</p> -->
        <!-- <p>Total PRice: {{ this.totalPrice }}</p> -->
        <!-- <p>Ekstras: {{ this.$store.getters.ekstras }}</p> -->
        <!-- <p>EkstrasSummary: {{ this.ekstrasSummary }}</p> -->

        <!-- TODO:
        Der skal laves en dispatch i Vuex store til at hente rabat info på email2 og returnere det så vi kan bruge det her til at vise rabat korrrekt
        Bemærk: hvis en rabatkode efterfølgende slettes/udløber vil bookingControlleren ligge fuld pris på den genererede faktura, samt tilkøbet. Dvs. der vil
        blive opkrævet fuld pris på tilkøbet, og genereret en faktura med fuld pris for bookingen, selvom der kun er betalt op til rabatten på selve bookingen.
        For at kunne få styr på dette vil det kræve at vi gemmer historisk rabatinfo med bookingen. - det vil være en større omskrivning.

        TODO:
        - Totalprisen skal beregnes efter rabat
       -->

        <div class="tabel">
            <table class="opsummeringIndhold">
                <thead>
                    <tr>
                        <th scope="col" width="34%">{{ $t('tilkoeb') }}</th>
                        <th scope="col" width="12%">{{ $t('vaerelse') }}</th>
                        <th scope="col" width="10%">{{ $t('antal') }}</th>
                        <th scope="col" width="20%">{{ $t('dato') }}</th>
                        <th scope="col" width="12%">{{ $t('prisstk') }}</th>
                        <th scope="col" width="12%">{{ $t('pris') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(summary, key, index) in ekstrasSummary" v-bind:key="`${key}-${index}`">
                        <td>{{ $store.getters.ekstras.find(obj => obj.id_rec===parseInt(summary.extraID)).overskrift }}</td>
                        <td v-bind:data-label="$t('ankomst')">{{ summary.room }}</td>
                        <td>{{ summary.antal_personer }}</td>
                          <!-- 
                            Hvis der er valgt flere datoer vil de komme ind som et array af objects, vi er derfor nødt til at checke først.
                            Hvis array, så behold kun de entries hvor date.checked er true og returnér til sidst komma-separeret liste af datoer. 
                            -->
                          <td v-if="Array.isArray(summary.date)">{{ summary.date.filter(date => date.checked == true).map(date => date.date).join(', ') }}</td>
                          <td v-else>{{ summary.date.date }}</td>
                        <td>{{ parseFloat(summary.price).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                        <td>{{ (summary.antal_personer * summary.antal_naetter * summary.price).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                    </tr>

                    <tr>
                      <td colspan="6">&nbsp;</td>
                    </tr>
                                        
                    <!-- Der er sat en rabat -->
                    <template v-if="Object.keys(this.$store.getters.rabat).length">

                          <!-- Procent rabat -->
                          <template v-if="this.$store.getters.rabat.procent">
                            <tr>
                              <td colspan="4">{{ $t('rabat') }}</td>
                              <td>DKK</td>
                              <td>{{ ((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)/(1+(this.momssats/100))) * (1-( (100-this.$store.getters.rabat.procent) / 100)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4">{{ $t('exmoms') }}</td>
                              <td>DKK</td>
                              <td>{{ ((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)/(1+(this.momssats/100))) * (1-( this.$store.getters.rabat.procent / 100)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4">{{ $t('moms') }}</td>
                              <td>DKK</td>
                              <td>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)*(this.momssats/(100+this.momssats)) * (1-( this.$store.getters.rabat.procent / 100)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4"><b>{{ $t('inclmoms') }}</b></td>
                              <td><b>DKK</b></td>
                              <td><b>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) * (1-( this.$store.getters.rabat.procent / 100)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</b></td>
                            </tr>
                          </template>

                          <!-- Krone rabat -->
                          <template v-else-if="this.$store.getters.rabat.kroner">
                            <tr>
                              <td colspan="4">{{ $t('rabat') }}</td>
                              <td>DKK</td>
                              <td>{{ (this.$store.getters.rabat.kroner ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4">{{ $t('exmoms') }}</td>
                              <td>DKK</td>
                              <td v-if="((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)/(1+(this.momssats/100))) - this.$store.getters.rabat.kroner ) > 0">{{ ((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)/(1+(this.momssats/100))) - this.$store.getters.rabat.kroner ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                              <td v-else>{{ (0).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4">{{ $t('moms') }}</td>
                              <td>DKK</td>
                              <td v-if="((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) - this.$store.getters.rabat.kroner) * (this.momssats/(100+this.momssats)) ) > 0">{{ ((ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) - (this.$store.getters.rabat.kroner*(this.momssats/100+1))) * (this.momssats/(100+this.momssats)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                              <td v-else>{{ (0).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                            </tr>
                            <tr>
                              <td colspan="4"><b>{{ $t('inclmoms') }}</b></td>
                              <td><b>DKK</b></td>
                              <td v-if="(ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) - this.$store.getters.rabat.kroner*(1+( this.momssats / 100)) ) > 0"><b>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) - this.$store.getters.rabat.kroner*(1+( this.momssats / 100)) ).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</b></td>
                              <td v-else><b>{{ (0).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</b></td>
                            </tr>
                          </template>
                        </template>


                    <!-- Uden Rabat -->
                    <template v-else>
                      <tr>
                        <td colspan="4">{{ $t('exmoms') }}</td>
                        <td>DKK</td>
                        <!-- Nedenstående .reduce ganger prisen med antal personer og antal nætter for alle ekstratilkøb for at finde totalbeløbet. Ekstratilkøb er opgivet incl. moms. -->
                        <td>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)/(1+(this.momssats/100))).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                      </tr>
                      <tr>
                        <td colspan="4">{{ $t('moms') }}</td>
                        <td>DKK</td>
                        <td>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)*(this.momssats/(100+this.momssats))).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</td>
                      </tr>
                      <tr>
                        <td colspan="4"><b>{{ $t('inclmoms') }}</b></td>
                        <td><b>DKK</b></td>
                        <td><b>{{ (ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) }}</b></td>
                      </tr>
                    </template>

                    
                </tbody>
            </table>
        </div>

        <div class="buttonContainer">
            <router-link to="opsummering">
                <div class="continueButton">
                    <a>&laquo; {{ $t('tilbage')}}</a>
                </div>
            </router-link>

        <div class="continueButton" style="opacity: 1.0;" v-on:click="handleCreditCard()">
          
            <!-- 
              1. api-kald til createRefNo
              2. når 1. er færdig, api-kald til at beregne checksum til QuickPay-form
              3. når 2. er færdig, tryk på 'submit' på den hidden QuickPay-form vi har indsat
            -->
            <form v-if="$store.getters.checksum" method="POST" action="https://payment.quickpay.net" ref="qpForm">
              <input v-bind:value="$store.getters.checksum.version" type="hidden" name="version">
              <input v-bind:value="$store.getters.checksum.merchant_id" type="hidden" name="merchant_id">
              <input v-bind:value="$store.getters.checksum.agreement_id" type="hidden" name="agreement_id">
              <input v-bind:value="$store.getters.checksum.order_id" type="hidden" name="order_id">
              <input v-bind:value="$store.getters.checksum.amount" type="hidden" name="amount">
              <input v-bind:value="$store.getters.checksum.currency" type="hidden" name="currency">
              <input v-bind:value="$store.getters.checksum.payment_methods" type="hidden" name="payment_methods">
              <input v-bind:value="$store.getters.checksum.continueurl" type="hidden" name="continueurl">
              <input v-bind:value="$store.getters.checksum.cancelurl" type="hidden" name="cancelurl">
              <input v-bind:value="$store.getters.checksum.callbackurl" type="hidden" name="callbackurl">
              <input v-bind:value="$store.getters.checksum.checksum" type="hidden" name="checksum">
            </form>

          
            <a>{{ $t('tilbetaling') }} &raquo;</a>          
        </div>

        </div>
    </div>
</template>

<script>
import i18n from '@/plugins/i18n';
//import { throws } from 'assert';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            hotel: this.$store.getters.afterAddonData.hotel,
            ekstrasSummary: [],
            overskrift1: "Mobil-overskrift 1",
            momssats: 25,
            totalPrice: 0,
            QuickPayForm: {
              checksum: null,
              refNo: null, 
            },
        };
    },
    created() {
        //this.filterDetailedEkstras(this.$store.getters.afterAddonData.detailedEkstras)
        this.filterDetailedEkstras(this.$store.getters.afterAddonData.detailedEkstras)
        //this.getMomssats(this.$store.getters.hotels)
        console.log('Hotel: '+this.$store.getters.afterAddonData.hotel)
        console.log('Momssats: '+this.momssats)
        console.log('ekstrasSummary: '+JSON.stringify(this.ekstrasSummary))
        
        
        // Hent rabatinfo
        this.$store.dispatch("getDiscountCode", {'email2': this.$store.getters.afterAddonData.booking.header.customer.email2, 'koncern': this.$route.params.koncern, 'hotel': this.$store.getters.afterAddonData.hotel, 'start': this.$store.getters.afterAddonData.booking.arrival, 'end': this.$store.getters.afterAddonData.booking.departure }).then( () => {

          // Beregn totalprisen for bestillingen
          if (Object.keys(this.$store.getters.rabat).length) {
            console.log('Der er registreret rabat, ændrer totalprisen...')
            if(this.$store.getters.rabat.procent) {
              this.totalPrice = this.ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) * (1-( this.$store.getters.rabat.procent / 100))
            } else if (this.$store.getters.rabat.kroner) {
              this.totalPrice = this.ekstrasSummary.reduce((total,summary) => total + (summary.antal_personer*summary.antal_naetter*summary.price), 0) - this.$store.getters.rabat.kroner*(1+( this.momssats / 100))
            } else {
              this.totalPrice = this.ekstrasSummary.reduce((totalPrice, summary) => totalPrice + (summary.antal_personer*summary.antal_naetter*summary.price), 0)
            }
          }

          // Hvis der er negativ totalpris sættes den til 0
          if(this.totalPrice < 0) {
            this.totalPrice = 0;
            console.log('Der er registreret negativ pris, sætter prisen til 0');
          }
        })

        // Beregn totalprisen
        this.getTotals();
    },
    methods: {
        /**
         * Gennemgå this.detailedEkstras og find alle de ekstra-tilkøb gæsten 
         * har tilvalgt, gem i this.ekstrasSummary, så vi senere kan vise dem i en oversigt
         */
        filterDetailedEkstras(detailedEkstras) {
            this.ekstrasSummary = []
            //detailedEkstras.forEach((ekstra, ekstraID) => {
            for(const [ekstraID, ekstra] of Object.entries(detailedEkstras)) {
                //console.log('Looper igennem detailedEkstras - ekstraID: '+ekstraID+' checked: '+ekstra.checked)

                for (var roomId in ekstra) {
                    if(ekstra.hasOwnProperty(roomId)) {
                        //console.log(roomId+' => '+JSON.stringify(ekstra[roomId]))
                        if(ekstra[roomId].checked == true && ekstraID) {
                            for(var ekstraDays in ekstra[roomId]) {
                                if(ekstra[roomId].hasOwnProperty(ekstraDays)) {
                                    //console.log('Der er bestilt ekstra ID ('+ekstraID+'): '+roomId+' => '+JSON.stringify(detailedEkstras[ekstraID][roomId]))

                                }
                            }

                            var nyEkstra = {extraID: ekstraID, date: ekstra[roomId].days, room: ekstra[roomId].room.room, price: ekstra[roomId].pris, antal_personer: ekstra[roomId].antal_personer, antal_naetter: ekstra[roomId].antal_naetter}
                            this.ekstrasSummary.push(nyEkstra)
                        }

                    }
                }
              }

            //console.log('ekstrasSummary efter filter: '+JSON.stringify(this.ekstrasSummary, undefined, 4))
        },




        /**
         * Returnerer ekstra objekt ud fra et ID
         * @param  {int} id  ID på ekstra tilkøb
         */
        filterAvailableEkstras(id) {          
           return this.$store.getters.ekstras.find(obj => obj.id_rec === id)
        },
        /**
         * Returner momssatsen for hotellet
         */
        getMomssats(hotels) {
            for (const [hotel] of Object.entries(hotels)) {
                if(this.$store.getters.afterAddonData.hotel == hotel.postnr) {
                    this.momssats = hotel.momssats;
                }
            }
        },
        handleCreditCard() {
          // gem ekstra getteren i en var da vi ikke kan accesse den i en forEach
          var ekstrasGetter = this.$store.getters.ekstras

          // gennemgå ekstrasSummary og tilføj en property 'overskrift' til hver object i ekstrasSummary
          // "|| {}).overskrift || []" gør at der returneres tomt objekt/array hvis værdien ikke findes, alternativt gives en "undefined"-error i JS konsollen.
          this.ekstrasSummary.forEach(function(part, index, summary) {
            summary[index]["headline"] = (ekstrasGetter.find(obj => obj.id_rec === parseInt(summary[index].extraID)) || {}).overskrift || [];
          });


          this.apiLoaded = 0;
          var bookingInProgress = {
            bookingTime: this.$store.getters.afterAddonData.bookingTime,
            doorcode: this.$store.getters.afterAddonData.doorcode,
            hotel: this.$store.getters.afterAddonData.hotel,
            hotelmail: this.$store.getters.afterAddonData.hotelmail,
            hotelname: this.$store.getters.afterAddonData.hotelname,
            koncern: this.$store.getters.afterAddonData.koncern,
            language: this.$store.getters.afterAddonData.language,
            fakturanr: this.$store.getters.afterAddonData.booking.header.hotel.fakturanr,
            arrival: this.$store.getters.afterAddonData.booking.arrival,
            departure: this.$store.getters.afterAddonData.booking.departure,
            amount: this.totalPrice*100,
            ekstrasSummary: this.ekstrasSummary
          }

          console.log('bookingInProgress der sendes med til QuickPay: '+JSON.stringify(bookingInProgress, undefined, 4))
          

/*          
            this.QuickPayForm.refNo = this.$store.getters.afterAddonData.booking.header.hotel.refno; 
            this.$store.dispatch("getChecksum", {
              'language': this.locale, 
              'amount': this.totalPrice*100, 
              'refNo': this.$store.getters.afterAddonData.booking.header.hotel.refno, 
              'koncern': this.$route.params.koncern, 
              'postnr': this.$store.getters.afterAddonData.hotel, 
              'customerData': this.$store.getters.afterAddonData.booking.header.customer, 
              'bookingInProgress': bookingInProgress, 
              'adminOrder': '/1'}).then(
              () => { 
                this.QuickPayForm.checksum = this.$store.getters.checksum; 
                this.apiLoaded = 1; 
                this.submitForm() ;
              }) 
          
        },

*/
        /**
         * Vi prøver at lave ekstra tilkøbene med det oprindelige referencenummer, men med fortløbende fakturanr eks. U798-x, og bruge fakturanr som ordrenr i QuickPay
         */
        
        this.$store.dispatch("getAddonRefNo", {'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.afterAddonData.hotel, 'fakturanr': this.$store.getters.afterAddonData.booking.header.hotel.fakturanr, 'refno': this.$store.getters.afterAddonData.booking.header.hotel.refno }).then(
            () => { this.QuickPayForm.refNo = this.$store.getters.refNo.refNo; this.$store.dispatch("getChecksum", {'language': this.locale, 'amount': this.totalPrice*100, 'refNo': this.$store.getters.refNo.refNo, 'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.afterAddonData.hotel, 'customerData': this.$store.getters.afterAddonData.booking.header.customer, 'bookingInProgress': bookingInProgress, 'adminOrder': '/1'}).then(
              () => { 
                this.QuickPayForm.checksum = this.$store.getters.checksum; 
                this.apiLoaded = 1; 
                this.submitForm() ;
              }) 
          }) 
        },
       
        submitForm() {
          if(this.QuickPayForm.checksum.checksum && this.QuickPayForm.checksum.checksum.length > 10) {
            document.forms[0].submit();
          }
        },
        getTotals() {
          this.totalPrice = this.ekstrasSummary.reduce((totalPrice, summary) => totalPrice + (summary.antal_personer*summary.antal_naetter*summary.price), 0)
        }
    }
}
</script>

<style scoped>

.flex-container {
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  -ms-flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.flex-item {
  padding: 10px;
  width: 85vw;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
}

/* Giver de enkelte input-elementer styling, hvid border, transparent baggrund og padding */
.form input[type="text"], [type="checkbox"], textarea {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
}

.form ::placeholder {
    color: rgba(255, 255, 255, 0.50);
}

/* Flex container, angiver hvordan den skal opføre sig ved smallere viewport */
.form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    max-width: 1024px;
    margin: 0 auto;
    
}
/* De enkelte kolonner i flexboxen */
.formColumn {
    flex: 0 0 30%;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 1;
}

.error {
    color: red;
    font-weight: bold;
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 50px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}

.tabel {
    vertical-align: top;
    background-color: whitesmoke;
    height: 60vh;
    margin-top: 10px;
    margin-bottom: 50px;
    margin-left: 10%;
    margin-right: 10%;
    overflow-y: auto;
    overflow-x: hidden;
}

table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  text-align: left;
  color: black;
  overflow: hidden;
}

table th {
  font-size: .95em;
  letter-spacing: .1em;
  text-transform: uppercase;
  word-wrap: break-word;
}

table td {
    font-size: .95em;
}

@media screen and (max-width: 640px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }
  
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  
  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  table td:last-child {
    border-bottom: 0;
  }
}

</style>